import { createApp } from 'vue';
import App from './App.vue';
import VueAxios from 'vue-axios';
import axios from 'axios';
import ga from './utils/ga.js';


const app = createApp(App);
app.use(VueAxios, axios);
app.config.globalProperties.ga = ga;
app.mount('#app');
